// extracted by mini-css-extract-plugin
module.exports = {"label":"DateRange_label__2Oegj","control":"DateRange_control__cDi-S"};